module.exports = __webpack_public_path__ + "img/map_6.c369d5d1.jpg";